import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Zoom from "@material-ui/core/Zoom";
// material-ui
import { withStyles } from "@material-ui/styles";
import hotkeys from "hotkeys-js";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

// styles
const styles = (theme) => ({
  root: {
    textAlign: "center",
    cursor: "pointer",
  },
  container: {
    padding: 5,
    cursor: "pointer",
  },
  tag: {
    background: theme.palette.background.paper,
    marginTop: 4,
    borderRadius: 12,
  },
});

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({});

class App extends Component {
  static propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    color: PropTypes.string,
    withName: PropTypes.bool,
    fullName: PropTypes.bool,
    name: PropTypes.string,
    icon: PropTypes.string,
    size: PropTypes.number,
    url: PropTypes.string,
    jiggle: PropTypes.bool,
    onSelect: PropTypes.func,
  };

  state = {
    hover: false,
    jiggle: false,
  };

  constructor(...args) {
    super(...args);
    if (this.props.jiggle) {
      hotkeys("*", (e) => {
        if (e.key === "Alt") {
          this.setState({ jiggle: true });
        }
      });
    }

    document.addEventListener("keyup", () => this.setState({ jiggle: false }));
  }

  render() {
    const {
      withName,
      color,
      name,
      size,
      classes,
      fullName,
      url,
      icon,
      theme,
      onSelect,
    } = this.props;

    const { hover, jiggle } = this.state;
    const transition = "ease-in";

    return (
      <div
        onClick={
          onSelect && jiggle
            ? () => onSelect(this.props)
            : () => window.open(`https://${url}`)
        }
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <Zoom in>
          <div className={classes.root}>
            {icon ? (
              <div
                className="icon"
                style={{
                  width: size,
                  height: size,
                  position: "relative",
                  margin: "auto",
                  listStyleType: "none",
                  paddingInlineStart: 0,
                  animationDelay: jiggle ? `-${Math.random()}s` : undefined,
                  animationDuration: jiggle
                    ? `.${Math.floor(Math.random() * 11) + 20}s`
                    : undefined,
                }}
              >
                <img
                  src={icon}
                  alt={name}
                  style={{
                    boxShadow:
                      jiggle || hover
                        ? "0 5px 18px 0 rgba(0,0,0,.3)"
                        : "0 5px 28px 0 rgba(0,0,0,.1)",
                    borderRadius: "20%",
                    position: "absolute",
                    left: `calc(50% - ${size / 2}px)`,
                    height: hover ? size + size * 0.1 : size,
                    width: hover ? size + size * 0.1 : size,
                    marginLeft: hover ? (-size * 0.1) / 2 : 0,
                    marginTop: hover ? (-size * 0.1) / 2 : 0,
                    transition: `height .1s ${transition}, width .1s ${transition}, margin-left .1s ${transition}, margin-top .1s ${transition}, box-shadow .2s ${transition}`,
                  }}
                />
              </div>
            ) : (
              <Paper
                style={{
                  paddingLeft: fullName ? 4 : undefined,
                  paddingRight: fullName ? 4 : undefined,
                  minWidth: fullName ? size : undefined,
                  width: fullName ? undefined : size,
                  margin: "auto",
                  height: size,
                  border: `solid ${size * 0.05}px ${color}`,
                  background: "#424242",
                  color,
                  fontFamily: "Futura",
                  fontSize: size * 0.5,
                  borderTopRightRadius: size * 0.5,
                  borderBottomLeftRadius: size * 0.5,
                }}
              >
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{ height: size }}
                >
                  <Grid item>{fullName ? name : `${name[0]}${name[1]}`}</Grid>
                </Grid>
              </Paper>
            )}
            {withName && (
              <Typography
                display="block"
                variant="body2"
                style={{
                  color: theme.palette.type === "dark" ? "white" : "black",
                  paddingTop: 8,
                }}
              >
                {name}
              </Typography>
            )}
          </div>
        </Zoom>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(App));
